var path = 'src/app/patients/forms/questionnaires.html';
var html = "<h1 class=page-header>Questionnaires <small>{{cohort.name}}</small></h1> <p ng-if=!forms.length> No questionnaires available for this patient. </p> <div ng-if=forms.length> <ul class=radar-tabs> <li ng-repeat=\"form in forms\" ui-sref-active=active> <a ui-sref=\"patient.questionnaire({formSlug: form.form.slug})\">{{form.form.name}} <span class=badge>{{form.count}}</span></a> </li> </ul> <div class=radar-body ui-view></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/forms/questionnaires.html
 ** module id = 467
 ** module chunks = 0
 **/